"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
/**
 * A hook that returns a debounced value
 *
 * @param value The value to debounce
 * @param delay The delay in milliseconds (defaults to 300ms)
 * @returns The debounced value
 */
function useDebounce(value, delay = 300) {
    const [debouncedValue, setDebouncedValue] = (0, react_1.useState)(value);
    (0, react_1.useEffect)(() => {
        // Set debouncedValue to value (passed in) after the specified delay
        const timer = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);
        // Return a cleanup function that will be called every time useEffect is re-called
        // Use the cleanup function to clear the timeout
        return () => {
            clearTimeout(timer);
        };
    }, [value, delay]);
    return debouncedValue;
}
exports.default = useDebounce;
